/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-08 11:01:02                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-03 12:16:29                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Styles
  * Components
  * Dashboard: dashboard view
*/

/* Imports */
import { useMemo, useState } from "react";
import { Typography } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
/***/

/* Styles */
import "./Dashboard.scss";
/***/

/* Components */
import OtherAction from "./sections/other-actions/OtherActions";
import QuotationsSection from "./sections/dashboard-cards/quotations/QuotationsSection";
import TechniciansSection from "./sections/dashboard-cards/technicians/TechniciansSection";
import ProspectsSection from "./sections/dashboard-cards/prospects/ProspectsSection";
import WorkorderSection from "./sections/dashboard-cards/workorders/WorkordersSection";
import DashboardPeriodSelect from "./DashboardPeriodSelect";
import DashboardTimeToField from "./DashboardTimeToField";
import { resolveDashboardPeriod, type DashboardPeriod } from "./dashboardPeriod";
/***/

/**
* Dashboard: dashboard view
* summarize application informations
*/
export function Dashboard() {
  const { t } = useTranslation();
  const [period, setPeriod] = useState<DashboardPeriod>("year");
  const range = useMemo(() => resolveDashboardPeriod(period), [period]);

  return (
    <div className="dashboard">
      <div className="dashboard-head">
        <Typography variant="h2">
          {t("common:dashboard")}
        </Typography>
        <DashboardPeriodSelect value={period} onChange={setPeriod} />
      </div>

      <DashboardTimeToField from={range.from} to={range.to} />

      <div className="card-container">
        <WorkorderSection from={range.from} to={range.to} />
        <ProspectsSection from={range.from} to={range.to} />
        <QuotationsSection from={range.from} to={range.to} />
        <TechniciansSection />
      </div>

      <OtherAction/>
    </div>
  );
}
/***/
